export enum Role {
  Dispatcher = 'Dispatcher',
  Begeleider = 'Begeleider'
}
